import { AdvisingAbnormalOperationUserBean } from "./advising-abnormal-operation-user-bean";

export class AdvisingAbnormalItemFilesRequest extends AdvisingAbnormalOperationUserBean {
  docIds: string[];


  constructor() {
    super();
    this.docIds=[];

 }
}
